/* eslint-disable
jsx-a11y/anchor-is-valid,
no-script-url,
max-len,
react/no-did-update-set-state,
react/no-unused-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import _, { mapObject, constant } from 'underscore';
import fileExtension from 'file-extension';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { DropdownSelector } from '@bingads-webui-react/dropdown-selector';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { Panel } from '@bingads-webui-campaign-react/panel';
import { TextField, ChoiceGroup, DefaultButton } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { PillControl } from '@bingads-webui-react/pill-control';
import { getAddImageStyle } from '@bingads-webui-campaign/shared-image-experience-styles';
import { VideoFilePicker, UploadProgress } from '@bingads-webui-campaign-react/upload-file-picker';
import { SearchBox } from '@bingads-webui-campaign-react/image-experience';
import { InvestImageDataService } from '@bingads-webui-campaign/invest-image-data-service';

import C from '../constants';
import { FormatVideoError } from '../util/format-video-error';
import UserVideoPickerContainer from './user-video/user-video-picker-container';
import InvestVideoPickerContainer from './invest-video/invest-video-picker-container';
import { initializeUserVideoDataSource } from './data-source/user-video-data-source';
import { initializeInvestVideoDataSource } from './data-source/invest-video-data-source';
import { ImageExperienceVideo } from '../model/image-experience-video';
import { UrlEditor } from './url-editor';
import { VideoRepository } from '../util/video-repository';
import { testThumbnail } from '../util/video-thumbnail-test';

class AddVideo extends React.PureComponent {
  constructor(props) {
    super(props);

    const {
      i18n,
      isXandrIntegrationEnabled,
    } = this.props;

    this.videoRepository = props.videoRepository || new VideoRepository(props.cid, props.aid, props.oDataConfig, props.activityLogger);

    this.userVideoDataSource = initializeUserVideoDataSource({
      videoRepository: this.videoRepository,
    });

    this.investImageDataService = new InvestImageDataService({ cid: props.cid, aid: props.aid });

    this.investVideoDataSource = initializeInvestVideoDataSource({
      investImageDataService: this.investImageDataService,
    });

    this.sortBySelectionItems = [
      {
        id: C.videoSortBySelections.recentUpload.id,
        value: i18n.getString('ImageExperience_Sort_Recent_Upload'),
      },
      {
        id: C.videoSortBySelections.description.id,
        value: i18n.getString('ImageExperience_Sort_Video_Text'),
      },
    ];

    this.defaultPillControlItems = [
      {
        name: i18n.getString('ImageExperience_Existing_Videos'),
        href: '#',
        value: 'existingVideos',
      },
      {
        name: i18n.getString('ImageExperience_Upload'),
        href: '#',
        value: 'upload',
      },
    ];

    this.investPillControlItem = {
      name: i18n.getString('ImageExperience_Invest'),
      href: '#',
      value: 'invest',
    };

    this.defaultState = {
      sortBySelection: this.sortBySelectionItems[0],
      blockUi: false,
      errors: [],
      pillControlIndex: 0,
      videoUploadUrl: '',
      videoUrl: '',
      uploadOptionKey: 'upload-local-file',
      searchValue: '',
      creativeId: '',
      pillControlItems: isXandrIntegrationEnabled ? [
        ...this.defaultPillControlItems, this.investPillControlItem,
      ] : this.defaultPillControlItems,
    };

    this.state = this.defaultState;
  }

  componentDidMount() {
    if (this.props.shouldShowContentOnly) {
      this.userVideoDataSource.searchAsync(null, this.state.sortBySelection.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.shouldShowContentOnly) {
      /* istanbul ignore next */
      return;
    }
    if (!this.props.isOpen) {
      this.setState(this.defaultState);
    }
    if (!prevProps.isOpen && this.props.isOpen && this.state.pillControlIndex === 0) {
      this.userVideoDataSource.searchAsync(null, this.state.sortBySelection.id);
    }
    if (!prevProps.isOpen && this.props.isOpen && this.props.isXandrIntegrationEnabled) {
      const pillControlItems = [
        ...this.defaultPillControlItems,
        this.investPillControlItem,
      ];
      this.setState({ pillControlItems });
    }
  }

  onUserVideoSearch = (searchValue) => {
    this.setState(
      { searchValue },
      () => this.userVideoDataSource.searchAsync(this.state.searchValue, this.state.sortBySelection.id)
    );
  };

  onInvestVideoSearch = (creativeId) => {
    this.setState(
      { creativeId },
      () => this.investVideoDataSource.searchAsync(this.state.creativeId)
    );
  };

  onSortBySelect = (sortBySelection) => {
    this.setState(
      { sortBySelection },
      () => this.userVideoDataSource.searchAsync(this.state.searchValue, this.state.sortBySelection.id)
    );
  };

  onPillChange = ({ index }) => {
    this.setState({
      pillControlIndex: index,
      errors: [],
    });

    if (this.props.isXandrIntegrationEnabled && index === 2) {
      this.investVideoDataSource.searchAsync(null);
    }
  };

  onUrlChanged = (e) => {
    this.setState({
      videoUrl: e.target.value,
    });
  };

  onUrlSubmit = () => {
    this.showUiBlocker(true);

    testThumbnail(this.state.videoUrl, 'url upload', this.props.activityLogger);
    const { videoUrl } = this.state;
    const { repairMode, videoList } = this.props;
    const invalidVideo = _.find(videoList, _video => _video.status === 'Failed');

    this.props.activityLogger.signal(fileExtension(videoUrl), 'video extension');

    const postVideoByUrlPromise = invalidVideo && repairMode ? this.videoRepository.replaceVideoByUrl({
      id: invalidVideo.idString,
      videoUrl,
    }) : this.videoRepository.postVideoByUrl({ videoUrl, description: '' });

    postVideoByUrlPromise
      .then((response) => {
        this.setState({ videoUrl: '' });
        if (repairMode && this.props.logToSubstrateAdvanced) {
          this.props.logToSubstrateAdvanced('repair finished', 'video repair');
        }

        this.props.onVideoPostByUrl(response, videoUrl);
      })
      .catch((error) => {
        /* istanbul ignore next */
        this.showErrors(FormatVideoError(error, this.props.i18n));
        /* istanbul ignore next */
        if (repairMode && this.props.logToSubstrateAdvanced) {
          this.props.logToSubstrateAdvanced(`repair error: ${error}`, 'video repair');
        }
      })
      .finally(() => {
        this.showUiBlocker(false);
      });
  };

  showErrors = errors => this.setState({ errors });

  showUiBlocker = shouldBlock => this.setState({ blockUi: shouldBlock });

  render() {
    const {
      i18n,
      isReplace,
      isLazyLoadEnabled,
      onVideoSelected,
      videoList,
      shouldShowContentOnly,
      isXandrIntegrationEnabled,
    } = this.props;

    const {
      pillControlIndex,
      sortBySelection,
      pillControlItems,
    } = this.state;

    const shouldShowExisting = pillControlIndex === 0;
    const shouldShowVideoUpload = pillControlIndex === 1;
    const shouldShowUploadProgress = pillControlIndex === 1 && this.props.isVideoUploading;
    const shouldShowInvest = isXandrIntegrationEnabled && pillControlIndex === 2;

    const uploadOptionMapping = {
      'upload-local-file': (
        <React.Fragment>
          <div className="upload-local-file-container">
            <TextField
              placeholder={i18n.getString('ImageExperience_Add_Video_File_Placeholder')}
              value={this.props.videoFile ? this.props.videoFile.name : ''}
              readOnly
              className="file-picker-input"
              ariaLabel={i18n.getString('ImageExperience_Add_Video_File_AriaLabel')}
            />
            {!shouldShowUploadProgress &&
              <VideoFilePicker
                onFileRead={this.props.onFileRead}
                showErrors={this.showErrors}
                i18n={i18n}
                isVideo
              />
            }
          </div>
          {
            shouldShowUploadProgress &&
            <React.Fragment>
              <UploadProgress
                totalBytes={this.props.videoFile.size}
                uploadedBytes={this.props.videoUploadedBytes}
                i18n={i18n}
              />
              <DefaultButton
                className="cancel-upload-button"
                ariaLabel={`${this.props.i18n.getString('Audience_Campaign_Cancel_Label')} ${this.props.i18n.getString('ImageExperience_Upload')}`}
                text={this.props.i18n.getString('Audience_Campaign_Cancel_Label')}
                onClick={this.props.onCancelUpload}
              />
            </React.Fragment>
          }
        </React.Fragment>),
      'upload-from-url': (
        <UrlEditor
          i18n={i18n}
          url={this.state.videoUrl}
          onUrlChanged={this.onUrlChanged}
          onSubmit={this.onUrlSubmit}
        />),
    };

    const addVideoContent = () => (
      <div className="add-image-content-container add-video-content-container">
        <div className="add-image-content">
          <div className="add-image-description">
            <span>
              {`${i18n.getString('ImageExperience_AddVideoDescription')} `}
            </span>
            <LearnMoreLink
              linkText={i18n.getString('ImageExperience_BestPracticeHelp_Video')}
              topic="app54794"
            />
          </div>
          <PillControl
            className="pill-control"
            defaultSelectedIndex={pillControlIndex}
            onItemChange={({ name, value, index }) => this.onPillChange({ name, value, index })}
            items={pillControlItems}
          />
          <div className="clearfix">
            {
              shouldShowExisting &&
              <div>
                <div className="user-image-search-box">
                  <SearchBox
                    onSearch={searchValue => this.onUserVideoSearch(searchValue)}
                    searchBoxPlacedHolderText={i18n.getString('ImageExperience_Sort_Video_Text')}
                    searchBoxAriaLabel={i18n.getString('ImageExperience_Sort_Video_Text')}
                  />
                </div>
                <div className="dropdown-selector-container">
                  <DropdownSelector
                    totalCount={2}
                    i18n={i18n}
                    selectedItem={sortBySelection}
                    onSelect={this.onSortBySelect}
                    mode="simple"
                    items={this.sortBySelectionItems}
                    dropdownMenuAriaLabel={i18n.getString('ImageExperience_SortBy')}
                    enableArrowKeysSupport
                    shouldFocusFirstFocusableItemOnMount
                  />
                </div>
                <span className="sort-by-label">
                  {i18n.getString('ImageExperience_SortBy')}
                </span>
              </div>
            }
          </div>
          {
            shouldShowExisting &&
            <UserVideoPickerContainer
              showUiBlocker={this.showUiBlocker}
              videoRepository={this.videoRepository}
              showErrors={this.showErrors}
              userVideoDataSource={this.userVideoDataSource}
              onVideoSelected={onVideoSelected}
              isLazyLoadEnabled={isLazyLoadEnabled}
              i18n={i18n}
              videoList={videoList}
              videoPickerContainerHeight={this.props.videoPickerContainerHeight}
            />
          }
          {
            shouldShowVideoUpload &&
            <ChoiceGroup
              className="upload-choice-group"
              defaultSelectedKey={this.state.uploadOptionKey}
              label={i18n.getString('ImageExperience_Choose_Video_Description')}
              options={[
                {
                  key: 'upload-local-file',
                  text: i18n.getString('ImageExperience_Add_Video_Option_Local'),
                  ariaLabel: i18n.getString('ImageExperience_Add_Video_Option_Local'),
                  onRenderField: (props, render) => (
                    <React.Fragment>
                      {render(props)}
                      {this.state.uploadOptionKey === 'upload-local-file' && uploadOptionMapping[this.state.uploadOptionKey]}
                    </React.Fragment>
                  ),
                  disabled: this.state.isVideoUploading,
                },
                {
                  key: 'upload-from-url',
                  text: i18n.getString('ImageExperience_Add_Video_Option_URL'),
                  ariaLabel: i18n.getString('ImageExperience_Add_Video_Option_URL'),
                  onRenderField: (props, render) => (
                    <React.Fragment>
                      {render(props)}
                      {this.state.uploadOptionKey === 'upload-from-url' && uploadOptionMapping[this.state.uploadOptionKey]}
                    </React.Fragment>
                  ),
                  disabled: this.state.isVideoUploading,
                },
              ]}
              onChange={(ev, option) => this.setState({ uploadOptionKey: option.key })}
              disabled={this.props.isVideoUploading}
            />
          }
          <div className="clearfix">
            {
              shouldShowInvest &&
              <div>
                <div className="invest-video-search-box">
                  <SearchBox
                    onSearch={creativeId => this.onInvestVideoSearch(creativeId)}
                    searchBoxPlacedHolderText={i18n.getString('ImageExperience_Creative_Id_Text')}
                    searchBoxAriaLabel={i18n.getString('ImageExperience_Creative_Id_Text')}
                  />
                </div>
              </div>
            }
          </div>
          {
            shouldShowInvest &&
            <InvestVideoPickerContainer
              showUiBlocker={this.showUiBlocker}
              showErrors={this.showErrors}
              investVideoDataSource={this.investVideoDataSource}
              videoRepository={this.videoRepository}
              onVideoSelected={onVideoSelected}
              isLazyLoadEnabled={isLazyLoadEnabled}
              i18n={i18n}
              videoPickerContainerHeight={this.props.videoPickerContainerHeight}
            />
          }
          {
            this.state.errors.map((errMsg, index) => (
              <div
                className="error"
                // eslint-disable-next-line react/no-array-index-key
                key={`${index}`}
              >
                {errMsg}
              </div>
            ))
          }
          <div className="add-image-button-bar">
            <button
              className="add-image-cancel-button btn btn-default"
              onClick={this.props.onSelectionCanceled}
            >
              {i18n.getString('Audience_Campaign_Cancel_Label')}
            </button>
          </div>
        </div>
      </div>
    );

    if (shouldShowContentOnly) {
      return addVideoContent();
    }

    return (
      <div className="add-video">
        {
          this.props.isOpen && (
            <Panel
              title={isReplace ?
                i18n.getString('ImageExperience_ReplaceVideoTitle') :
                i18n.getString('ImageExperience_AddVideoTitle')}
              isOpen
              onClose={this.props.onSelectionCanceled}
              getContainer="body"
              panelClassName={this.props.classes.addImageStyle}
              i18n={i18n}
              panelReadyAriaLabel={i18n.getString('Add video side panel opened')}
            >
              <UiBlocker
                blocking={this.state.blockUi}
                loadingText={i18n.getString('Loading')}
              >
                {addVideoContent()}
              </UiBlocker>
            </Panel>
          )
        }
      </div>
    );
  }
}

AddVideo.propTypes = {
  isOpen: PropTypes.bool,
  onVideoSelected: PropTypes.func.isRequired,
  onSelectionCanceled: PropTypes.func.isRequired,
  isReplace: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape(mapObject(
    getAddImageStyle({}, {}),
    constant(PropTypes.string)
  )).isRequired,
  cid: PropTypes.string,
  aid: PropTypes.string.isRequired,
  isXandrIntegrationEnabled: PropTypes.bool,
  isLazyLoadEnabled: PropTypes.bool.isRequired,
  videoRepository: PropTypes.shape({
    postVideoByUrl: PropTypes.func.isRequired,
  }).isRequired,
  oDataConfig: PropTypes.shape({
    odataRootUrl: PropTypes.string,
    odataPath: PropTypes.string,
    odataToken: PropTypes.string,
    applicationName: PropTypes.string,
    oDataTokenType: PropTypes.string,
  }),
  staticImagePath: PropTypes.string,
  videoFile: PropTypes.instanceOf(File),
  isVideoUploading: PropTypes.bool,
  repairMode: PropTypes.bool,
  videoUploadedBytes: PropTypes.number,
  onFileRead: PropTypes.func.isRequired,
  onCancelUpload: PropTypes.func.isRequired,
  onVideoPostByUrl: PropTypes.func.isRequired,
  logToSubstrateAdvanced: PropTypes.func,
  videoList: PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceVideo)),
  activityLogger: PropTypes.shape({
    signal: PropTypes.func.isRequired,
  }),
  shouldShowContentOnly: PropTypes.bool,
  videoPickerContainerHeight: PropTypes.number,
};

AddVideo.defaultProps = {
  isReplace: false,
  isOpen: false,
  cid: '',
  isXandrIntegrationEnabled: false,
  staticImagePath: null,
  videoFile: null,
  repairMode: false,
  isVideoUploading: false,
  videoUploadedBytes: 0,
  videoList: [],
  logToSubstrateAdvanced: null,
  oDataConfig: null,
  activityLogger: {
    signal: _.noop,
  },
  shouldShowContentOnly: false,
  videoPickerContainerHeight: null,
};

const AddVideoContainer = withDefaultStyles(withPerfMarker(AddVideo), getAddImageStyle);

export { AddVideoContainer, AddVideo };
